/**
 * Корневой "/" route — редиректит на /overview.
 * AuthGuard внутри /authed (см. _authed.tsx) перехватит дальше
 * и отправит на /login, если пользователь не аутентифицирован.
 */

import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/')({
  beforeLoad: () => {
    throw redirect({ to: '/overview' });
  },
  component: () => null,
});
